import { createApiSlice } from "@common";
import {
  CRUD_CUSTOMER_BUSINESS_DETAILS,
  GET_CUSTOMER_BUSINESS_DETAILS_BY_CUSTOMER_ID,
} from "@routes";

const apiConfig = [
  {
    name: "addCustomerBusinessDetails",
    method: "post",
    url: CRUD_CUSTOMER_BUSINESS_DETAILS,
    stateKey: "message",
  },
  {
    name: "getCustomerBusinessDetailsByCustomerId",
    method: "get",
    url: GET_CUSTOMER_BUSINESS_DETAILS_BY_CUSTOMER_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "customerBusinessDetails",
  apiConfig,
  customReducers
);

const customerBusinessDetailsSlice = slice;

export default customerBusinessDetailsSlice.reducer;

export const {
  addCustomerBusinessDetails,
  getCustomerBusinessDetailsByCustomerId,
} = thunks;
